import { ApiServices } from "../../../services/api_services";
import { COREURL } from "../../../constants/api_constants";
import { ROLES } from "../../../base/constant";
import { createAsyncThunk } from "@reduxjs/toolkit";

const routingProfile = createAsyncThunk("users/get_routing_list", async () => {
  return ApiServices.get(COREURL, `/get_routing_list`)
    .then((response) => {
      return response;
    })
    .catch((error) => error);
});

const skillList = createAsyncThunk("users/get_skill_list", async () => {
  return ApiServices.get(COREURL, `/get_skill_list`)
    .then((response) => {
      return response;
    })
    .catch((error) => error);
});

const getUserListforReportTo = createAsyncThunk("users/get_user_list_by", async () => {
  return ApiServices.get(COREURL, `/get_user_list_by/${ROLES.OWNER_ROLE_ID},${ROLES.SUB_OWNER_ROLE_ID},${ROLES.ADMIN_ROLE_ID},${ROLES.SUPERVISOR_ROLE_ID}`)
    .then((response) => {
      return response;
    })
    .catch((error) => error);
});

export { routingProfile, skillList, getUserListforReportTo };
